/* GlobifySIM – country ticker
 *
 * Das Band läuft dauerhaft von rechts nach links und lässt sich gleichzeitig
 * mit dem Finger oder der Maus schneller schieben. Umgesetzt über die
 * Bildlaufposition statt über eine CSS-Animation: nur so lässt sich beides
 * verbinden, ohne dass sich Bewegung und Wischen in die Quere kommen.
 */
(function () {
  "use strict";

  function name(z) { return z.en || z.de; }

  function ruhigGewuenscht() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function aufbauen(bahn) {
    var reihe = bahn.querySelector("[data-gs-band-reihe]");
    if (!reihe) return;

    var ziele = (window.GS_ZIELE || []).filter(function (z) { return z.region !== "paket"; });
    if (!ziele.length) { bahn.parentNode.style.display = "none"; return; }

    var muster = bahn.getAttribute("data-gs-ziel-link") || "/products/";

    function eintrag(z) {
      var a = document.createElement("a");
      a.className = "gs-band__land";
      a.href = muster.indexOf("/products") >= 0
        ? muster.replace(/\/?$/, "/") + z.handle
        : muster + encodeURIComponent(name(z));
      a.innerHTML = '<span class="gs-band__flagge">' + z.flagge + "</span>" +
                    '<span class="gs-band__name">' + name(z) + "</span>";
      return a;
    }

    /* Zweimal dieselbe Liste: sobald die erste Hälfte durchgelaufen ist,
       springen wir unsichtbar zurück an den Anfang. */
    for (var runde = 0; runde < 2; runde++) {
      var teil = document.createElement("div");
      teil.className = "gs-band__haelfte";
      if (runde === 1) teil.setAttribute("aria-hidden", "true");
      ziele.forEach(function (z) { teil.appendChild(eintrag(z)); });
      reihe.appendChild(teil);
    }

    bahn.classList.add("ist-schiebbar");

    if (ruhigGewuenscht()) return;   /* dann nur schieben, keine Eigenbewegung */

    var tempo = parseInt(bahn.getAttribute("data-gs-tempo") || "70", 10);
    var laeuft = true;
    var pausiertBis = 0;
    var letzteZeit = null;

    function haelfte() {
      var erste = reihe.firstElementChild;
      return erste ? erste.scrollWidth : 0;
    }

    function schritt(zeit) {
      if (letzteZeit === null) letzteZeit = zeit;
      var vergangen = zeit - letzteZeit;
      letzteZeit = zeit;

      var breite = haelfte();
      if (breite > 0 && laeuft && Date.now() > pausiertBis) {
        /* Strecke je Millisekunde, damit das Tempo unabhängig von der
           Bildrate gleich bleibt */
        var proMs = breite / (tempo * 1000);
        bahn.scrollLeft += proMs * Math.min(vergangen, 60);
      }

      /* nahtlos umschlagen, in beide Richtungen */
      if (breite > 0) {
        if (bahn.scrollLeft >= breite) bahn.scrollLeft -= breite;
        else if (bahn.scrollLeft <= 0) bahn.scrollLeft += breite;
      }

      window.requestAnimationFrame(schritt);
    }

    window.requestAnimationFrame(schritt);

    function anhalten() { laeuft = false; }
    function weiter(verzoegerung) {
      pausiertBis = Date.now() + (verzoegerung || 0);
      laeuft = true;
    }

    bahn.addEventListener("pointerdown", anhalten);
    bahn.addEventListener("touchstart", anhalten, { passive: true });
    window.addEventListener("pointerup", function () { weiter(1200); });
    bahn.addEventListener("touchend", function () { weiter(1600); }, { passive: true });

    /* Beim Wischen mit Schwung nicht dagegenarbeiten */
    var scrollPause;
    bahn.addEventListener("scroll", function () {
      window.clearTimeout(scrollPause);
      pausiertBis = Date.now() + 900;
      scrollPause = window.setTimeout(function () { laeuft = true; }, 900);
    }, { passive: true });

    /* Am Rechner: beim Überfahren anhalten, damit man klicken kann */
    if (window.matchMedia && window.matchMedia("(hover: hover)").matches) {
      bahn.addEventListener("mouseenter", anhalten);
      bahn.addEventListener("mouseleave", function () { weiter(0); });
    }

    /* Nicht im Hintergrund weiterlaufen lassen */
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) laeuft = false;
      else { letzteZeit = null; weiter(0); }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-band]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
